import { TransitionControlUIFactory } from "./types";
import {
  DataType,
  ConfigType,
  builder,
  typeIsConfigType,
} from "@auditcloud/shared/lib/workflow/modules/Measure/transitionControls/notifications";
import component from "../AMeasureTransitionNotificationControl.reg.vue";

const factory: TransitionControlUIFactory<DataType, ConfigType> = config => {
  return {
    component,
    ...builder(config),
  };
};

export default {
  factory,
  typeIsConfigType,
};
